import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/football', label: '赛事分类' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className={`ri-fire-line text-2xl ${scrolled ? 'text-primary-500' : 'text-background-50'}`}></i>
            </div>
            <span
              className={`text-xl font-heading font-bold whitespace-nowrap ${
                scrolled ? 'text-primary-500' : 'text-background-50'
              }`}
            >
              开云体育
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? scrolled
                      ? 'text-primary-500'
                      : 'text-accent-500'
                    : scrolled
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-background-50/80 hover:text-background-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap px-4 py-2 rounded-md border transition-all duration-200 ${
                scrolled
                  ? 'border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-background-50'
                  : 'border-background-50/40 text-background-50 hover:bg-background-50/20'
              }`}
            >
              注册
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap px-4 py-2 rounded-md transition-all duration-200 ${
                scrolled
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-accent-500 text-background-950 hover:bg-accent-400'
              }`}
            >
              登录
            </Link>
          </div>

          <button
            className={`md:hidden w-8 h-8 flex items-center justify-center ${scrolled ? 'text-foreground-800' : 'text-background-50'}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 shadow-lg">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 whitespace-nowrap ${
                  location.pathname === link.path ? 'text-primary-500' : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 pt-2 border-t border-background-200/60">
              <Link to="/about" className="flex-1 text-center text-sm font-medium px-4 py-2 rounded-md border border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 whitespace-nowrap">
                注册
              </Link>
              <Link to="/about" className="flex-1 text-center text-sm font-medium px-4 py-2 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap">
                登录
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}